import React, {useEffect, useState} from 'react';
import _ from "lodash";

import Page from "../Components/Page";
import {
    convertToQueryParams,
    getBooleanParamOrDefault,
    getIntParamOrDefault,
    getStringArrayParamOrDefault,
    getStringParamOrDefault
} from "../../utils/urlBuilder";
import {Breadcrumbs} from "../Components/Breadcrumbs";
import OpsAlertsContent from "./OpsAlertsContent";
import {useServiceBase} from "../Components/ReactTable/useServiceBase";
import {LoadingWrapper} from "../Components/LoadingWrapper";
import {makeApolloClientCall} from "../../Api/makeApolloApiCall";

const OpsAlerts = () => {
    const apiParams = []
    const [showAcknowledgedAlerts, updateShowAcknowledgedAlerts] = useState(getStringParamOrDefault("showAcknowledgedAlerts", false))
    const [salesforceRetailerLookup, setSalesforceRetailerLookup] = useState({})

    useEffect(() => {
        makeApolloClientCall(`query { salesforceRetailers { retailerId onboardingStatus } }`)
            .then(result => setSalesforceRetailerLookup(_.keyBy(result.salesforceRetailers, 'retailerId')))
            .catch(() => setSalesforceRetailerLookup({}))
    }, []);

    const days = getIntParamOrDefault("days", undefined)
    if (days !== undefined) {
        apiParams.push(`days=${days}`)
    }
    const alertIdParams = getStringArrayParamOrDefault("alertIds", [])
    if (alertIdParams.length > 0) {
        apiParams.push(convertToQueryParams({alertIds: alertIdParams}))
    }
    const startDate = getStringParamOrDefault("startDate", undefined)
    if (startDate !== undefined) {
        apiParams.push(`startDate=${startDate}`)
    }
    const endDate = getStringParamOrDefault("endDate", undefined)
    if (endDate !== undefined) {
        apiParams.push(`endDate=${endDate}`)
    }
    const endpoint = (startDate && endDate) ? `opsAlertLogsByDate` : `opsAlertLogs`;
    const includeAcknowledged = getBooleanParamOrDefault('includeAcknowledged', showAcknowledgedAlerts)
    apiParams.push(`includeAcknowledged=${includeAcknowledged}`)

    const endpointUrl = `${process.env.REACT_APP_EDP_API_BASE_URL}/${endpoint}/?${apiParams.join('&')}`;
    const {loading, data} = useServiceBase({endpointUrl});

    const breadcrumbs =
        <Breadcrumbs items={[{label: 'Alerts'}, {label: 'Summary', to: '/alerts/summary'}, {label: 'Acknowledge'}]}/>;
    return <Page name="Alerts" breadCrumbs={breadcrumbs}>
        <LoadingWrapper loading={loading}>
            <OpsAlertsContent url={endpointUrl}
                              data={data}
                              showAcknowledgedAlertsProps={{showAcknowledgedAlerts, updateShowAcknowledgedAlerts}}
                              showAcknowledgedAlertsButton={true}
                              salesforceRetailerLookup={salesforceRetailerLookup}
            />
        </LoadingWrapper>
    </Page>
};

export default OpsAlerts;
